import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies,
  palette,
  fontSizes,
}: Theme) => ({
  formControlRoot: {},
  formControlLabelRoot: {
    minWidth: 'unset',
    margin: '0 0 18px',
    alignItems: 'flex-start',
    '& .MuiTypography-root': {
      minWidth: 'unset',
    },
  },
  formControlRootIconType: {
    margin: 0,
  },
  formControlLabelLabel: {
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
    fontFamily: fontFamilies.primary,
    paddingTop: 2,
    '& a': {
      color: palette.primary.dark,
    },
    '& a sup': {
      display: 'inline-block',
    },
  },
  checkboxRoot: {
    padding: 0,
    marginRight: '0.5rem',
    '&$checkboxRoot:hover': {
      backgroundColor: 'transparent',
    },
  },
  checkboxRootIcontype: {
    marginRight: 0,
  },
  formHelperTextRoot: {
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
    fontFamily: fontFamilies.primary,
    margin: '0 0 18px',
    '&$formHelperTextError': {
      color: palette.error.main,
    },
  },
  formHelperTextError: {},
}));
